export default "__VITE_ASSET__ZOPy9RyY__"